import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { NetworkTableFilterSchema } from './_list/-zod-schema';

export const Route = createFileRoute('/_staff/networks/_layout/')({
  validateSearch: zodValidator(NetworkTableFilterSchema),
});
